export default __webpack_public_path__ + "static/media/03-small.50c977fa.jpg";